import qs from "qs";
import { type IFile } from "@services/jointBillServices/types";
import { type IOverviewJointBillService } from "@services/overview/types";
import { api } from "@/api";
import {
  type IGetJointBillServicesExpectedPaymentAmountRequestParams,
  type IInitiatePaymentRequestParams,
  type IPaymentTaxCollectorTypes,
  type TPayment,
} from "./types";

export const getPaymentTaxCollectorTypes = async () =>
  (await api.get<IPaymentTaxCollectorTypes>("/customers/tax-collector-types"))
    .data;

export const updatePaymentTaxCollectorType = async (
  taxCollectorTypeId: string,
) =>
  api
    .put<string>("/customers/tax-collector-types", { taxCollectorTypeId })
    .then((r) => r.data);

export const initiatePayment = (data: IInitiatePaymentRequestParams) =>
  api
    .post<TPayment>("/payments", {
      periodId: data.periodId,
      selectedJointBillServices: data.selectedJointBillServiceIds.map(
        (jbs) => ({ jointBillServiceId: jbs, donationAmount: 0 }),
      ),
    })
    .then((r) => r.data);

export const getJointBillServicesExpectedPaymentAmount = (
  data: IGetJointBillServicesExpectedPaymentAmountRequestParams,
): Promise<number> =>
  api
    .get<{ expectedPayment: number }>(
      "/joint-bill-services/bills/expected-payment",
      {
        params: {
          PeriodId: data.periodId,
          JointBillServiceIds: data.selectedJointBillServiceIds,
        },
        paramsSerializer: (params) => {
          return qs.stringify(params);
        },
      },
    )
    .then((r) => r.data?.expectedPayment);

export const getPaperBillFile = ({
  jointBillServiceId,
  periodId,
}: {
  jointBillServiceId: IOverviewJointBillService["jointBillServiceId"];
  periodId: number;
}) =>
  api
    .get<IFile>(
      `/payments/joint-bill-services/${jointBillServiceId}/periods/${periodId}/pdf`,
      {
        timeout: 60000,
      },
    )
    .then((r) => r.data);
